export const MARKETMAP = "MARKETMAP";
export const MARKETMAP_ERROR = "MARKETMAP_ERROR";
export const MARKETMAP_HIDE_ERROR = "MARKETMAP_HIDE_ERROR";
export const MARKETMAP_START_LOADER = "MARKETMAP_START_LOADER";
export const MARKETMAP_STOP_LOADER = "MARKETMAP_STOP_LOADER";
export const MARKETMAP_SELECTED_DATA = "MARKETMAP_SELECTED_DATA";
export const MARKETMAP_STREAM = "MARKETMAP_STREAM";
